import { render, staticRenderFns } from "./WaterNo.vue?vue&type=template&id=90b91de6&scoped=true&"
import script from "./WaterNo.vue?vue&type=script&lang=js&"
export * from "./WaterNo.vue?vue&type=script&lang=js&"
import style0 from "./WaterNo.vue?vue&type=style&index=0&id=90b91de6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b91de6",
  null
  
)

export default component.exports